import { useEffect } from "react";
import { LOGIN_TOKEN_URL_PARAM, ROUTES } from "@nf/constants";
import { AuthStore, dispatch, useAuthSelector } from "@nf/common";
import { useRouter } from "next/router";
import { useIsAuthenticated } from "./useIsAuthenticated";
import { useCountry } from "./useCountry";
import { useLanguage } from "./useLanguage";

export const useSyncWebUser = () => {
  const { isLoggedIn } = useIsAuthenticated();
  const { syncStatus } = useAuthSelector();

  const router = useRouter();
  const country = useCountry();
  const language = useLanguage();

  useEffect(() => {
    const excludedRoutes = [
      ROUTES.LOGOUT,
      ROUTES.LOGIN,
      ROUTES.SIGN_UP_PAYMENT,
    ].find((x) => router.asPath.includes(x));
    const hasLoginToken = !!router.query[LOGIN_TOKEN_URL_PARAM];

    if (
      !isLoggedIn &&
      !hasLoginToken &&
      !excludedRoutes &&
      syncStatus === "idle"
    ) {
      dispatch(AuthStore.Actions.syncWebUser(country, language));
    }
  }, [router.asPath, isLoggedIn, syncStatus, country, language]);
};

export const useSyncCompleted = (): boolean => {
  const { isCompleted: isAuthProcessCompleted } = useAuthSelector();
  return isAuthProcessCompleted ?? false;
};
